export function PageLoader() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-label="Cargando">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-semantic-border border-t-semantic-accent" />
    </div>
  );
}

interface EmptyStateProps {
  title: string;
  description: string;
  action?: React.ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <h2 className="text-fluid-xl font-heading font-semibold text-semantic-text-primary">{title}</h2>
      <p className="mt-2 max-w-md text-semantic-text-secondary">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

interface AlertBannerProps {
  variant?: 'info' | 'warning' | 'demo';
  children: React.ReactNode;
}

export function AlertBanner({ variant = 'info', children }: AlertBannerProps) {
  const styles = {
    info: 'bg-blue-50 border-blue-200 text-blue-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    demo: 'bg-gold/10 border-gold/30 text-charcoal',
  };
  return (
    <div className={`rounded-lg border px-4 py-3 text-sm ${styles[variant]}`} role="status">
      {children}
    </div>
  );
}
